import React from "react";
import { LongTextLabel, Toast } from "@sscs/ui";
import { Dialog } from "Components";
import { Member } from "Types";
import { apiErrorToast } from "Utils";
import { useDeleteUserMutation } from "../../services/users.api";

type DeleteMemberProps = {
  member: Member;
  isOpen: boolean;
  onClose: () => void;
};

const RemoveMember = ({
  member,
  isOpen,
  onClose,
}: DeleteMemberProps): React.JSX.Element => {
  const [deleteUser] = useDeleteUserMutation();

  const handleDelete = async () => {
    try {
      await deleteUser({
        userId: member.user_id,
      }).unwrap();

      Toast.show({
        title: "Removed member from the organization",
        type: "success",
      });
    } catch (error) {
      apiErrorToast(error, "Could not remove member from the organization");
    }

    onClose();
  };

  return (
    <Dialog
      title="Remove member?"
      confirmText="Remove"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={handleDelete}
      cancelButtonColor="primary"
      confirmButtonColor="secondary"
    >
      <div>
        Are you sure you want to remove{" "}
        <b>
          <LongTextLabel label={member.email} maxCharacters={100} inline />
        </b>{" "}
        from the organization?
      </div>
    </Dialog>
  );
};

export default RemoveMember;
